import { render, staticRenderFns } from "./AltAlertIcon.vue?vue&type=template&id=1c320b0c&scoped=true"
import script from "./AltAlertIcon.vue?vue&type=script&lang=js"
export * from "./AltAlertIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c320b0c",
  null
  
)

export default component.exports